import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FirstStepEHSWebsite from './FirstStepEHSWebsite';
import RiskAssessmentTool from './RiskAssessmentTool';
import PaymentSuccess from './PaymentSuccess';
import Blog from './Blog';
import BlogPost from './BlogPost';

function App() {
  return (
    <Router>
      <Routes>
        {/* Home/Marketing Pages */}
        <Route path="/" element={<FirstStepEHSWebsite />} />
        <Route path="/about" element={<FirstStepEHSWebsite />} />
        <Route path="/contact" element={<FirstStepEHSWebsite />} />
        <Route path="/privacy" element={<FirstStepEHSWebsite />} />
        
        {/* Assessment Tool */}
        <Route path="/assessment" element={<RiskAssessmentTool />} />
        
        {/* Payment Success */}
        <Route path="/payment-success" element={<PaymentSuccess />} />
        
        {/* Blog Routes */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </Router>
  );
}

export default App;